import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Chalisa = () => {
  return <AstroStaticPage data={Data} />;
};

export default Chalisa;
